export const environment = {
  production: false,
  apiUrl: 'https://dev-triapi.trivia.zone/',
  restApiUrl: 'https://dev-triapi.trivia.zone/',
  dctapiUrl: 'https://dev-triapi.trivia.zone/do-action',
  loginUrl: 'https://dev-triapi.trivia.zone/do-app-action',
  triviaRushApiUrl: 'https://apidev.trivialrush.com/',
  triviaMaticBaseApiUrl: 'http://preview.triviamatic.com:5000/',
  triviaMaticBaseUrl: 'http://preview.triviamatic.com',
  // restApiUrl: 'http://admindev.trebektrivia.com:5000/',
  gameDefaultThemeId: 'aa3808ee-aacf-4e8f-bd03-8365849fd013',
};
